import React from 'react';
import { Typography } from '../../typography';
import Icons from '@/const/icons';
import { Icon } from '../../icon';
import clsx from 'clsx';
import { TabListPreview } from '@/interfaces';
import { Check } from 'lucide-react';
import { useRouter } from 'next/router';
import AppRoutes from '@/const/routes';

interface Props {
	isDropdownOpen: boolean;
	handleSelectOption: (item: TabListPreview) => void;
	itemSelected: string;
	channels: TabListPreview[];
	dropdownRef: React.RefObject<HTMLDivElement>;
}

export const DropdownTab: React.FC<Props> = ({
	isDropdownOpen,
	itemSelected,
	handleSelectOption,
	channels,
}) => {
	const router = useRouter();
	const { id, search, applyToAll } = router.query;

	const mapLabel: Record<string, string> = {
		google_ads: 'Google Display',
		google_search: 'Google Search',
		facebook_ads: 'Facebook Ads',
		instagram_ads: 'Instagram Ads',
	};

	const isAd = channels.every((item) =>
		['google_ads', 'google_search', 'facebook_ads', 'instagram_ads'].includes(
			item.name
		)
	);
	return (
		<div
			className={clsx(
				'absolute top-13 left-0 z-20',
				isDropdownOpen ? 'block' : 'hidden'
			)}
		>
			<div className="bg-white shadow-[0px_14px_42px_0px_rgba(8,_15,_52,_0.06)] rounded-[32px] p-4 w-[262px]">
				<Typography type="semibold-16">{isAd ? 'Ads' : 'Posts'}</Typography>
				<div className="flex flex-col gap-y-4 mt-4">
					{channels.map((item, key) => (
						<React.Fragment key={'dropdown-' + key}>
							<div className="flex items-center gap-x-2 w-full">
								<button
									className={clsx(
										'border border-[#0D061633] rounded-full p-[2px]'
									)}
									onClick={() => {
										handleSelectOption(item);
										// router.push(
										// 	`${AppRoutes.LAWYERAPP_MARKETING_CAMPAIGN}/${id}?tab=${item.name}`
										// );

										router.push({
											pathname: `${AppRoutes.LAWYERAPP_MARKETING_CAMPAIGN}/${id}`,
											query: {
												tab: item.name,
												...(search && { search }),
												...(applyToAll && { applyToAll }),
											},
										});
									}}
								>
									<div
										className={clsx(
											'rounded-full size-4',
											itemSelected === item.name ? 'bg-green-60' : 'bg-gray-15'
										)}
									></div>
								</button>
								<div className="flex items-center justify-between w-full">
									<div className="flex gap-x-[10px] items-center">
										{item.icon}
										<Typography type="regular-14" className=" capitalize">
											{mapLabel[item.name] || item.name}
										</Typography>
									</div>
									<div>
										{item.approved && (
											<span className="rounded-full bg-purple-150 size-4 flex items-center justify-center">
												<Check
													color="#FFF"
													width={12}
													height={12}
													className="mt-0.5"
												/>
											</span>
										)}
										{!item.approved && (
											<Icon
												src={Icons.infoCircle}
												className="!size-4 text-main-orange"
											/>
										)}
									</div>
								</div>
							</div>
						</React.Fragment>
					))}
				</div>
			</div>
		</div>
	);
};
